import React from 'react';
import DownloadJSONButton from './DownloadJSONButton';
import ImportJSONButton from './ImportJSONButton';
import { Menu } from 'semantic-ui-react';
import CreateOutputFileButton from './CreateOutputFileButton';

class JMenu extends React.Component {

  render() {
    const {primary} = this.props;
    
    return(
      <Menu>
        <DownloadJSONButton primary={primary} />
        <ImportJSONButton jsonImport={this.props.jsonImport} />
        <CreateOutputFileButton primary={primary} />
      </Menu>
    );
  }
}

//<input type='file' style={{display: 'none'}} onChange={this.handleUpload} accept=".json">

export default JMenu;